<div class="category-management">
  <!-- Header Section -->
  <div class="row mb-4">
    <div class="col-md-6">
      <h4>Category Management</h4>
      <p class="text-muted">Manage your product categories</p>
    </div>
    <div class="col-md-6 text-end">
      <button class="btn btn-primary" (click)="openAddCategoryDialog()">
        <nb-icon icon="plus-outline"></nb-icon>
        Add Category
      </button>
    </div>
  </div>

  <!-- Search and Filters -->
  <nb-card class="mb-4">
    <nb-card-body>
      <div class="row align-items-center">
        <div class="col-md-6">
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              placeholder="Search categories..."
              [(ngModel)]="searchQuery"
              (keyup.enter)="onSearch()">
            <button class="btn btn-outline-secondary" type="button" (click)="onSearch()">
              <nb-icon icon="search-outline"></nb-icon>
            </button>
          </div>
        </div>
        <div class="col-md-3">
          <select class="form-select" [(ngModel)]="sortBy" (change)="onSortChange()">
            <option value="name">Name</option>
            <option value="displayOrder">Display Order</option>
            <option value="createdAt">Date Created</option>
            <option value="productsCount">Products Count</option>
          </select>
        </div>
        <div class="col-md-3">
          <button class="btn btn-outline-secondary" (click)="loadCategories()">
            <nb-icon icon="refresh-outline"></nb-icon>
            Refresh
          </button>
        </div>
      </div>
    </nb-card-body>
  </nb-card>

  <!-- Categories Grid -->
  <div *ngIf="!loading && categories.length > 0" class="row">
    <div class="col-lg-4 col-md-6 mb-4" *ngFor="let category of categories; trackBy: trackByCategoryId">
      <nb-card class="category-card h-100">
        <nb-card-body class="d-flex flex-column">
          <!-- Category Image -->
          <div class="category-image mb-3">
            <img
              *ngIf="getImageUrl(category.imageUrl)"
              [src]="getImageUrl(category.imageUrl)"
              [alt]="category.name"
              class="img-fluid rounded"
              (error)="onImageError($event)">
            <div *ngIf="!getImageUrl(category.imageUrl)" class="placeholder-image">
              <nb-icon icon="image-outline"></nb-icon>
            </div>
          </div>

          <!-- Category Info -->
          <div class="category-info flex-grow-1">
            <h5 class="category-name mb-2">
              {{ category.name }}
              <span *ngIf="category.isVisible === false" class="badge bg-secondary ms-1" style="font-size:0.7rem;">Hidden</span>
            </h5>
            <p class="category-description text-muted" *ngIf="category.description">
              {{ category.description }}
            </p>
            <div class="category-meta">
              <span class="badge bg-primary me-2">
                <nb-icon icon="cube-outline"></nb-icon>
                {{ category.productsCount || 0 }} products
              </span>
              <span class="badge bg-secondary">
                Order: {{ category.displayOrder || 0 }}
              </span>
            </div>
          </div>

          <!-- Action Buttons (only when management is enabled) -->
          <div class="category-actions mt-3">
            <ng-container *ngIf="category.managementEnabled; else lockedActions">
              <button
                class="btn btn-sm btn-outline-primary me-2"
                (click)="editCategory(category)"
                nbTooltip="Edit Category">
                <nb-icon icon="edit-outline"></nb-icon>
                Edit
              </button>
              <button
                class="btn btn-sm btn-outline-danger"
                (click)="deleteCategory(category._id)"
                nbTooltip="Delete Category">
                <nb-icon icon="trash-outline"></nb-icon>
                Delete
              </button>
            </ng-container>
            <ng-template #lockedActions>
              <span class="text-muted d-flex align-items-center gap-1">
                <nb-icon icon="lock-outline"></nb-icon>
                Locked
              </span>
            </ng-template>
          </div>

          <!-- Management Toggle -->
          <div class="mt-3 pt-2 border-top">
            <nb-toggle
              [checked]="category.managementEnabled"
              (checkedChange)="toggleManagement(category)"
              status="primary">
              Active management
            </nb-toggle>
          </div>
        </nb-card-body>
      </nb-card>
    </div>
  </div>

  <!-- Empty State -->
  <div *ngIf="!loading && categories.length === 0" class="text-center py-5">
    <nb-card>
      <nb-card-body>
        <nb-icon icon="layers-outline" class="large-icon text-muted mb-3"></nb-icon>
        <h5>No Categories Found</h5>
        <p class="text-muted" *ngIf="searchQuery">
          No categories match your search criteria.
          <button class="btn btn-link p-0" (click)="clearSearch()">Clear search</button>
        </p>
        <p class="text-muted" *ngIf="!searchQuery">
          Start by creating your first product category.
        </p>
        <button class="btn btn-primary" (click)="openAddCategoryDialog()">
          <nb-icon icon="plus-outline"></nb-icon>
          Create Your First Category
        </button>
      </nb-card-body>
    </nb-card>
  </div>

  <!-- Loading State -->
  <div *ngIf="loading" class="text-center py-5">
    <nb-spinner size="large"></nb-spinner>
    <p class="mt-3 text-muted">Loading categories...</p>
  </div>
</div>
